import { DefaultTheme } from "styled-components";
import ITheme from "./ITheme";

const darkTheme: ITheme = {
  hall_of_fame: {
    text_color: "#fff",
    secondary_text_color: "#79531F",
    third_text_color: "#906325",
    main_color: "#4D2608",
    border_color: "#724E1D",
    background_color: "#202020",
    secondary_background_color: "#A1712B",
    third_background_color: "#C89D4B",
    background_hover: "#FFF6B1",
    font_size_primary: "24px",
    font_size_mobile_primary: "12px",
  },
  background: {
    main: "#202020",
    gradient:
      "linear-gradient(-45deg, #D7B563 0%, #DCBD53 9.38%, #B2843C 26.04%, #F4E478 58.85%, #BB913D 78.13%, #CDA865 90.63%, #D7B563 100%)",
    second: "#202020",
    sidebar: "#202020",
    header: "#202020",
    mobileHeader: "#363636",
    secondHeader: "#000",
  },
  primary: {
    hover: "#e3bd77",
    main: "#E7B556",
    light: "#E7B556",
    black: "#000000",
    white: "#ffffff"
  },
  secondary: {
    main: "#363636",
    focused: "#5F5F5F",
    disabled: "#A1A1A1",
  },
  text: {
    main: "#FFFFFF",
    second: "#000000",
    listMenu: "#E7B556",
  },
  success: {
    main: "#C89D4B",
  },
  error: {
    main: "#CB2011",
  },
  warning: {
    main: "#202020",
  },

  main_card: {
    background: "#000000",
  },
  icons: {
    input: "#FFFFFF",
  },
};

const lightTheme: ITheme = {
  hall_of_fame: {
    text_color: "#fff",
    secondary_text_color: "#79531F",
    third_text_color: "#906325",
    main_color: "#4D2608",
    border_color: "#724E1D",
    background_color: "#202020",
    secondary_background_color: "#A1712B",
    third_background_color: "#C89D4B",
    background_hover: "#FFF6B1",
    font_size_primary: "24px",
    font_size_mobile_primary: "12px",
  },
  background: {
    main: "#ffffff",
    gradient:
      "linear-gradient(-45deg, #D7B563 0%, #DCBD53 9.38%, #B2843C 26.04%, #F4E478 58.85%, #BB913D 78.13%, #CDA865 90.63%, #D7B563 100%)",
    second: "#202020",
    sidebar: "#ffffff",
    header: "#ffffff",
    mobileHeader: "#ffffff",
    secondHeader: "#ebebeb",
  },
  primary: {
    hover: "#f5d4d4",
    main: "#E7B556",
    light: "#E7B556",
    black: "#000000",
    white: "#ffffff"
  },
  secondary: {
    main: "#EBEBEB",
    focused: "#cbcbcb",
    disabled: "#A1A1A1",
  },
  text: {
    main: "#202020",
    second: "#ebebeb",
    listMenu: "#E7B556",
  },
  success: {
    main: "#C89D4B",
  },
  error: {
    main: "#CB2011",
  },
  warning: {
    main: "#202020",
  },

  main_card: {
    background: "#ebebeb",
  },
  icons: {
    input: "#FFFFFF",
  },

  providers: {
    background: '#5F5F5F'
  }
};

const dark: DefaultTheme = { mode: "dark", palette: darkTheme };
const light: DefaultTheme = { mode: "light", palette: lightTheme };

export default {dark, light};
